import { render, staticRenderFns } from "./procurement-types.vue?vue&type=template&id=4403ac1c&"
import script from "./procurement-types.vue?vue&type=script&lang=js&"
export * from "./procurement-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports